<div class="row col-12 dashboard newComplaintType ">
  <form class="form-container" [formGroup]="form">
    <!-- First Row: Contains both filter boxes side by side -->
    <div class="first-row">
      <!-- First Box: Range From and Range To -->
      <div class="box boxees">
        <div class="date-range-header">
          <h5>Date Range Filter</h5>
        </div>
        <div class="row align-items-center">
          <!-- Date From -->
          <div class="col-auto">
            <mat-form-field appearance="outline">
              <mat-label>Range From</mat-label>
              <input matInput [matDatepicker]="dateFromPicker" formControlName="dateFrom" readonly />
              <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateFromPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Date To -->
          <div class="col-auto">
            <mat-form-field appearance="outline">
              <mat-label>Range To</mat-label>
              <input matInput [matDatepicker]="dateToPicker" formControlName="dateTo" readonly />
              <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateToPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Second Box: Assignee and Chart Type -->
      <div class="box boxees">
        <div class="date-range-header">
          <h5>Other Filters</h5>
        </div>
        <div class="row align-items-center bars">
          <!-- Assignee -->
          <div class="col-auto">
            <mat-form-field appearance="outline">
              <mat-label>Assignee</mat-label>
              <mat-select formControlName="assignTo" [disabled]="assignRoleAdmin"
                (selectionChange)="onAssigneeSelect($event.value)">
                <mat-option [value]="''">ALL</mat-option>
                <mat-option *ngFor="let user of usersList" [value]="user.userId">
                  {{user.userName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Chart Type -->
          <div class="col-auto">
            <mat-form-field appearance="outline">
              <mat-label>Chart Type</mat-label>
              <mat-select formControlName="chartType" (selectionChange)="onChartTypeChange($event.value)">
                <mat-option value="bar">Bar</mat-option>
                <mat-option value="column">Column</mat-option>
                <mat-option value="line">Line</mat-option>
                <mat-option value="area">Area</mat-option>
                <mat-option value="scatter">Scatter</mat-option>
                <mat-option value="pie">Pie</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Third Box: Other Elements (Conditional Fields) -->
    <div>
      <div class="row align-items-center">
        @if (f['complaintType'].value != '') {
        <div class="col-auto">
          <mat-form-field appearance="outline">
            <mat-label>Complaint Type</mat-label>
            <input matInput formControlName="complaintType" />
          </mat-form-field>
        </div>
        }

        @if (f['division'].value != '') {
        <div class="col-auto">
          <mat-form-field appearance="outline">
            <mat-label>Division</mat-label>
            <input matInput formControlName="division" />
          </mat-form-field>
        </div>
        }

        @if (f['district'].value != '') {
        <div class="col-auto">
          <mat-form-field appearance="outline">
            <mat-label>District</mat-label>
            <input matInput formControlName="district" />
          </mat-form-field>
        </div>
        }

        @if (f['tehsil'].value != '') {
        <div class="col-auto">
          <mat-form-field appearance="outline">
            <mat-label>Tehsil</mat-label>
            <input matInput formControlName="tehsil" />
          </mat-form-field>
        </div>
        }
      </div>
    </div>
  </form>

  <div class="col-12 breadcrumb-container mb-3">
    <div class="col-lg-12 col-md-12 ps-0">
      @for (d of drillDown;track d) {
      @if (d.type == 'Mouza') {
      {{ d.type }} - {{ d.point }}
      } @else if (d.type == 'Division' || d.type == 'District' || d.type == 'Tehsil' ) {
      <a (click)="drillback(d)">{{ d.type }} - {{ d.point }}</a> ->
      }
      }
    </div>
  </div>

</div>
<div class="col-12 dashboard-container">
  <div class="charts-grid">
    <!-- Chart 1 -->
    <div class="chart-card">
      <highcharts-chart [Highcharts]="chart4" [options]="chart4Options" [(update)]="updateFlag4">
      </highcharts-chart>
    </div>

    <!-- Chart 2 -->
    <div class="chart-card">
      <div class="chart-header">
        @if (this.f['complaintType'].value != "") {
        <a (click)="goBackToCategories()"><- {{this.f['complaintType'].value}}</a>
            }
      </div>
      <highcharts-chart [Highcharts]="chart3" [options]="chart3Options" [(update)]="updateFlag3">
      </highcharts-chart>
    </div>

    <!-- Chart 3 -->
    <div class="chart-card">
      <div class="chart-header">
        @if (chartsFiltered && selectedComplaintStatus) {
        <a (click)="resetComplaintStatusChart()">
          <- {{ selectedComplaintStatus==='Total Appeal Complaints' ? 'Total Registered Complaints' :
            selectedComplaintStatus }}</a>
            }
      </div>
      <highcharts-chart [Highcharts]="chart1" [options]="chart1Options" [(update)]="updateFlag">
      </highcharts-chart>
    </div>

    <!-- Chart 4 -->
    <div class="chart-card">
      <div class="chart-header">
        @if (chartsFiltered && selectedAppealStatus) {
        <a (click)="resetAppealStatusChart()"><- {{ selectedAppealStatus }}</a>
            }
      </div>
      <highcharts-chart [Highcharts]="chart2" [options]="chart2Options" [(update)]="updateFlag">
      </highcharts-chart>
    </div>
  </div>
</div>